module.exports = __webpack_public_path__ + "static/eBusiness-title-64d1e049930a85f51eae8ccf28b3b342.svg";